const INITIAL_STATE = {
  studentDetails: {},
  studentResumeData: {},
  studentEditData: {
    admin: {
      email: '',
      phoneNumber: '',
      firstName: '',
      lastName: '',
      dob: '',
      gender: '',
    },
    student: {
      uniRollNo: '',
      startBatch: '',
      endBatch: '',
      middelName: '',
      passedOut: '',
      profileUrl: '',
    },
    studentPersonalProfile: {
      father: '',
      mother: '',
      caste: '',
      religion: '',
      registraionNo: '',
      idProof: [],
      addressProof: [],
      secondaryEmail: '',
      preferredJobLocation: [],
      languages: [],
      hobbies: [],
      socialMedia: [],
      permAddrLine1: '',
      permAddrLine2: '',
      permCity: '',
      permState: '',
      permPostCode: '',
      isSameCorresponding: '',
      corrAddrLine1: '',
      corrAddrLine2: '',
      corrCity: '',
      corrState: '',
      corrPostCode: '',
      extraCurriculars: '',
      gender: '',
    },
    currentCourse: {},
    education: [],
    resume: {
      objective: '',
      projects: [],
      internships: [],
      courses: [],
      training: [],
      awards: [],
      workExperience: [],
    },
  },
  campusDetails: '',
  degreeList: '',
  token: '',
  countryList: [],
  stateList: [],
  cityList: [],
  skillList: [],
  functionsList: {},
  designationList: {},
  industryList: {},
  listOfSkills: {},
  universityList: [],
  extEventData: null,
}

const getUpdatedEducationData = educationList => {
  const updatedList = educationList.map(
    ({ degreeStreamMapId, educationLevel, tcUrl, ...rest }) => {
      if (educationLevel === 'tenth' || educationLevel === 'twelfth') {
        return { ...rest, educationLevel, tcUrl: tcUrl || {} }
      } else {
        return { ...rest, degreeStreamMapId, educationLevel, tcUrl }
      }
    }
  )
  return updatedList
}

export const onboarding = (state = INITIAL_STATE, action) => {
  let student;
  let personalData;
  switch (action.type) {
    case 'SET_STUDENT_DATA':
    student = action?.payload
    personalData = student?.studentPersonalProfile
      return {
        ...state,
        studentDetails: action.payload,
        studentEditData: {
          admin: {
            email: student?.admin?.email,
            phoneNumber: student?.admin?.phone_number,
            firstName: student?.firstName,
            lastName: student?.lastName,
            dob: personalData?.dob,
            gender: personalData?.gender,
            countryCode: student?.admin?.country_code,
          },
          student: {
            uniRollNo: student?.uniRollNo,
            startBatch: student?.startBatch,
            endBatch: student?.endBatch,
            middelName: student?.middelName,
            passedOut: student?.passedOut,
            profileUrl: student?.profileUrl,
            isExpCandidate: student?.isExpCandidate,
            instituteCampusId: student?.instituteCampusId,
            instituteCampusName: student?.instituteCampusName,
          },
          studentPersonalProfile: {
            father: personalData?.father,
            mother: personalData?.mother,
            caste: personalData?.caste,
            religion: personalData?.religion,
            registraionNo: student?.uniRollNo,
            idProof: personalData?.idProof || [],
            addressProof: personalData?.addressProof || [],
            secondaryEmail: personalData?.secondaryEmail,
            preferredJobLocation: personalData?.preferredJobLocation || [],
            languages: personalData?.languages || [],
            hobbies: personalData?.hobbies,
            socialMedia: personalData?.socialMedia || [],
            permAddrLine1: personalData?.permAddrLine1,
            permAddrLine2: personalData?.permAddrLine2,
            permCity: personalData?.permCity,
            permState: personalData?.permState,
            permCountry: personalData?.permCountry,
            permCityId: personalData?.permCityId,
            permStateId: personalData?.permStateId,
            permCountryId: personalData?.permCountryId,
            permPostCode: personalData?.permPostCode,
            isSameCorresponding: personalData?.isSameCorresponding,
            corrAddrLine1: personalData?.corrAddrLine1,
            corrAddrLine2: personalData?.corrAddrLine2,
            corrCity: personalData?.corrCity,
            corrState: personalData?.corrState,
            corrCountry: personalData?.corrCountry,
            corrCityId: personalData?.corrCityId,
            corrStateId: personalData?.corrStateId,
            corrCountryId: personalData?.corrCountryId,
            corrPostCode: personalData?.corrPostCode,
            isPhysicallyChallenged: personalData?.isPhysicallyChallenged,
            physicalChallenge: personalData?.physicalChallenge,
            isAnywhere: personalData?.isAnywhere,
            extraCurriculars: personalData?.extraCurriculars,
            gender: personalData?.gender,
          },
          currentCourse: student?.currentCourse,
          education: getUpdatedEducationData(student?.educationProfile) || [],
          resume: {
            objective: student?.resume?.objective,
            projects: student?.resume?.projects || [],
            internships: student?.resume?.internships || [],
            courses: student?.resume?.courses || [],
            training: student?.resume?.training || [],
            awards: student?.resume?.awards || [],
            workExperience: student?.resume?.workExperience || [],
          },
        },
      }
    case 'SET_RESUME_DATA':
      return {
        ...state,
        studentResumeData: action?.payload,
      }
    case 'SET_DEGREE_LIST':
      return {
        ...state,
        degreeList: action?.list,
      }
    case 'SET_SKILLS_LIST':
      return {
        ...state,
        listOfSkills: action.data,
      }
    case 'SET_UNIVERSITY_LIST':
      return {
        ...state,
        universityList: action.data,
      }

    case 'SET_CAMPUS_DETAILS':
      return {
        ...state,
        campusDetails: action?.name,
      }
    case 'SET_TOKEN':
      return {
        ...state,
        token: action?.token,
      }

    case 'SET_LIST_OF_COUNTRY':
      return {
        ...state,
        countryList: action?.list,
      }

    case 'SET_LIST_OF_STATE':
      return {
        ...state,
        stateList: action?.list,
      }

    case 'SET_LIST_OF_CITY':
      return {
        ...state,
        cityList: action?.list,
      }
    case 'SET_LIST_OF_SKILL':
      return {
        ...state,
        skillList: action?.list,
      }
    case 'SET_FUNCTIONS_LIST':
      return {
        ...state,
        functionsList: action.data,
      }
    case 'SET_DESIGNATION_LIST':
      return {
        ...state,
        designationList: action.data,
      }
    case 'SET_INDUSTRY_LIST':
      return {
        ...state,
        industryList: action.data,
      }
    case 'SET_EXT_EVENT_DATA':
      return {
        ...state,
        extEventData: action?.data,
      }
    default:
      return state
  }
}
